import type { HelpFile } from '../../types/help'
import { ConnectorOverviewCardTestIds } from '../../../testids/ConnectorOverviewCardTestIds'

export const connectorOverviewCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [ConnectorOverviewCardTestIds.cardConnectorOverview]: 'Summary of this connector — target system, type, and current status.',
    [ConnectorOverviewCardTestIds.linkTargetSystem]: null,
  },
}
